export const environment = {
  production: false,
  environmentName: 'development',
  apiUrl: 'https://dev.api.barbulls.com',
  wsUrl: 'wss://dev.api.barbulls.com',
  firebase: {
    apiKey: '',
    authDomain: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },
  features: {
    enableDebug: true,
    enableLogging: true,
    enableAnalytics: false
  },
  googleClientId: '1050699508803-la07i6kfio9b1bpv0ppmqgppnqm7cbu4.apps.googleusercontent.com'
};